import { IconSize } from './Icon.types';
//
import badgeCheck from './assets/badge-check.svg?raw';
import calendar from './assets/calendar.svg?raw';
import currencyDollar from './assets/currency-dollar.svg?raw';
import filter from './assets/filter.svg?raw';
import lockClosed from './assets/lock-closed.svg?raw';
import lockOpen from './assets/lock-open.svg?raw';
import viewList from './assets/view-list.svg?raw';
import x from './assets/x.svg?raw';

export const ICONS = {
  'badge-check': `data:image/svg+xml;utf8,${badgeCheck}`,
  'currency-dollar': `data:image/svg+xml;utf8,${currencyDollar}`,
  'lock-closed': `data:image/svg+xml;utf8,${lockClosed}`,
  'lock-open': `data:image/svg+xml;utf8,${lockOpen}`,
  'view-list': `data:image/svg+xml;utf8,${viewList}`,
  filter: `data:image/svg+xml;utf8,${filter}`,
  x: `data:image/svg+xml;utf8,${x}`,
  calendar: `data:image/svg+xml;utf8,${calendar}`,
};

export const ICON_SIZE: Record<IconSize, number> = {
  sm: 16,
  md: 24,
  lg: 32,
};
